// extracted by mini-css-extract-plugin
export default {"adminLayout":"AdminLayout_adminLayout__39GHe","mainContent":"AdminLayout_mainContent__QtOR5"};